import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    FieldWrappers,
    ModalHeader,
    ModalTitle,
} from "../../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import DropZone from "../../Notice/Dropzone";

const documentSchema = Yup.object().shape({
    title: Yup.string()
        .required("Title is required")
        .min(3, "Title must be at least 3 characters"),
    file: Yup.mixed().required("File is required"),
});

const PropertyDocumentUploadModal = ({ setIsDocumentAdd, uploadDocMutate, isDocLoading, propId }) => {
    const initialDocumentValues = {
        title: "",
        file: null,
    };

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleDocumentSubmit = (values) => {
        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("file", values.file[0]);
        formData.append("propId", propId);
        uploadDocMutate(formData);
    };

    return (
        <Container
            style={{
                height: `${height}px`,
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
            }}
        >
            <ModalHeader>
                <ModalTitle>Upload Document</ModalTitle>
                <button onClick={() => setIsDocumentAdd(false)}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialDocumentValues}
                    onSubmit={handleDocumentSubmit}
                    validationSchema={documentSchema}
                >
                    {({ values, setFieldValue, errors, touched }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                                <Wrapper>
                                    {/* Title Field */}
                                    <InputGroup>
                                        <Label htmlFor="title">Document Title *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                name="title"
                                                id="title"
                                                autoComplete="off"
                                                required
                                                placeholder="Enter document title (e.g., Electricity Bill, NOC Letter, etc.)"
                                            />
                                        </FieldWrappers>
                                        {errors.title && touched.title && (
                                            <ErrorMessage>{errors.title}</ErrorMessage>
                                        )}
                                    </InputGroup>

                                    {/* File Upload */}
                                    <InputGroup>
                                        <Label htmlFor="file">Upload Document *</Label>
                                        <FieldWrapper $select={true}>
                                            <Field
                                                required
                                                name="file"
                                                type="text"
                                                id="file"
                                                autoComplete="off"
                                            >
                                                {(props) => (
                                                    <DropZone
                                                        fields={props.field}
                                                        setFieldValue={props.form.setFieldValue}
                                                        componentFor="expense"
                                                        acceptedFiles="image/*,application/pdf"
                                                        File={
                                                            props.field.value ? [props.field.value] : null
                                                        }
                                                    />
                                                )}
                                            </Field>
                                        </FieldWrapper>
                                        {errors.file && touched.file && (
                                            <ErrorMessage>{errors.file}</ErrorMessage>
                                        )}
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn
                                    type="button"
                                    onClick={() => setIsDocumentAdd(false)}
                                    disabled={isDocLoading}
                                >Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit"
                                    disabled={isDocLoading}
                                >
                                    {isDocLoading ? "Updating..." : "Upload"}</SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

// Styled components
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const FieldWrapper = tw.div`w-full`;

export default PropertyDocumentUploadModal;
